var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { feedback: true, scrollTop: _vm.scrollTop },
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "feedback-btn",
        attrs: {
          href: "https://user-railway.hbgyl.com.cn/Home/Railway",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "imgOne",
          attrs: {
            src: require("../../assets/icon/zhongoujingjia.png"),
            alt: ""
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b29f642c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b29f642c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/feedback.vue
// module id = null
// module chunks = 